import http from "../../http-common";

class PellesDataService {

  upload(files, onUploadProgress) {
    let formData = new FormData();

    for(let i = 0; i < files.length; i++){
      formData.append('file', files[i]);
    }

    return http.post("/fichierpelles/upload/", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress,
    });
  }

  getFiles() {
    return http.get("/fichierpelles/getListFiles");
  }

  getAll() {
    return http.get("/pelles");
  }

  get(id) {
    return http.get(`/pelles/${id}`);
  }

  create(data) {
    return http.post("/pelles", data);

  }

  update(id, data) {
    return http.put(`/pelles/${id}`, data);

  }

  delete(id) {
    return http.delete(`/pelles/${id}`);
  }

  deleteAll() {
    return http.delete(`/pelles`);
  }

  findByTitle(Nom) {
    return http.get(`/pelles?nom=${Nom}`);
  }
}

export default new PellesDataService();